import { globalSettingModel } from '@models/global-setting.model';
import { memo, type FC } from 'react';
import styles from './index.module.scss';

const Buy: FC<{
  token_address: string;
  name: string;
  symbol: string;
  iconUrl: string;
}> = ({ token_address, name, symbol, iconUrl }) => {
  return (
    <>
      <div
        className={styles.btn_buy}
        onClick={(e) => {
          globalSettingModel.setTradeVisible({
            visible: true,
            token_address,
            name,
            symbol,
            iconUrl,
          });
          e.stopPropagation();
        }}
      >
        Buy
      </div>
    </>
  );
};

export default memo(Buy);
